<template>
  <div class="helper-nav">
    <div class="helper-nav-real-rate">
    
      <span class=" titr">نرخ لحظه:</span>
        
      <div v-if="state_prices" class="helper-nav-real-rate-inner">
        <div class="rate-box buy">{{ state_prices.sale_price }}</div>
        <div class="rate-box sell">{{ state_prices.buy_price }}</div>
      </div>

      <div class="mx-2 titr">تومان</div>
        
    </div>
    <div>
      <router-link :to="{name:'Transaction'}" class="ar-btn size-sm primary">خرید و فروش فوری</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HelperNav',
  data : () => ({
  }),
  methods:{
  },
  mounted() {
  }
}
</script>